import N8nActionToggle from './ActionToggle.vue';

export default N8nActionToggle;
